import { loadScript, pickTruthy } from '@merakiplace/utils';
import { useEffect } from 'react';

const KAKAO_SDK_URL = 'https://developers.kakao.com/sdk/js/kakao.js';

const useKakaoShare = (query: URLSearchParams) => {
  const env = query.get('env');
  const isDEV = env === 'DEV';
  const key = isDEV ? 'a9e02f926c48b00bdcb8c3e83d11fbfe' : '2c4f0c728f06faabeb28a15c9ca9d369';

  const title = query.get('title');
  const description = query.get('description');
  const imageUrl = query.get('imageUrl');
  const imageHeight = query.get('imageHeight');
  const imageWidth = query.get('imageWidth');
  const mobileWebUrl = query.get('mobileWebUrl');
  const webUrl = query.get('webUrl');
  const androidExecutionParams = query.get('androidExecutionParams');
  const iosExecutionParams = query.get('iosExecutionParams');
  const buttonTitle = query.get('buttonTitle');

  const reward_policy_internal_name = query.get('rewardPolicyInternalName');
  const share_type = query.get('share_type');
  const tx_id = query.get('tx_id');
  const dong_id = query.get('dong_id');

  const userIdMatch = navigator.userAgent?.match(/userId=(\d+)/);
  const userId = userIdMatch ? Number(userIdMatch[1]) : null;

  const linkObject = pickTruthy({
    mobileWebUrl,
    webUrl,
    androidExecutionParams,
    iosExecutionParams,
  });

  const contentObject = {
    ...pickTruthy({ title, description, imageUrl }),
    imageHeight: Number(imageHeight) || 120,
    imageWidth: Number(imageWidth) || 188,
    link: linkObject,
  };

  const buttonObject = {
    title: buttonTitle || '앱에서 보기',
    link: linkObject,
  };

  // 서버 계약: server `benefit/kakao_share/serializers.py`
  const serverCallbackArgs = share_type
    ? pickTruthy({ share_type, tx_id, dong_id, user_id: userId })
    : pickTruthy({ reward_policy_internal_name, user_id: userId });

  const kakaoShare = () => {
    if (window.Kakao) {
      const kakao = window.Kakao;
      if (!kakao.isInitialized()) {
        kakao.init(key);
      }

      kakao.Share.sendDefault({
        objectType: 'feed',
        content: contentObject,
        buttons: [buttonObject],
        serverCallbackArgs,
      });
    }
  };

  useEffect(() => {
    let cancelled = false;
    loadScript(KAKAO_SDK_URL, { id: 'kakao-sdk' })
      .then(() => {
        if (!cancelled) {
          kakaoShare();
        }
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return kakaoShare;
};

export default useKakaoShare;
